import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowsRotate,
  faBan,
  faBoxArchive,
  faCircleCheck,
  faCircleXmark,
  faClipboardList,
  faEnvelope,
  faHome,
  faPaperPlane,
  faUsers,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";

/** Single primary nav entry with optional nested links */
export type SideBarNavItem = {
  label: string;
  route: string;
  icon: IconDefinition;
  subData?: { label: string; route: string }[];
};

const SideBarData: SideBarNavItem[] = [
  { label: "Dashboard", route: "/", icon: faHome },
  { label: "Chase List", route: "/chaselist", icon: faClipboardList },
  {
    label: "Pending-Invite",
    route: "/chase/Pending-Invite",
    icon: faBan,
    subData: [],
  },
  { label: "Inviting", route: "/chase/Inviting", icon: faPaperPlane },
  {
    label: "Auto-Renewals",
    route: "/chase/Auto-Renewals",
    icon: faArrowsRotate,
  },
  { label: "Renewed", route: "/chase/Renewed", icon: faCircleCheck },
  { label: "Failed", route: "/chase/Failed", icon: faCircleXmark },
  {
    label: "Payment-Failed",
    route: "/chase/Payment-Failed",
    icon: faCircleXmark,
  },
  {
    label: "Customer Archives",
    route: "/customer-archives",
    icon: faBoxArchive,
  },
  { label: "My Customers", route: "/my-customers", icon: faUsers },
  { label: "Agents", route: "/agents", icon: faUsersGear },
  { label: "Message Templates", route: "/message-templates", icon: faEnvelope },
];

export default SideBarData;
